import { render } from "./PersianDateField.vue?vue&type=template&id=5590bb63"
import script from "./PersianDateField.vue?vue&type=script&lang=js"
export * from "./PersianDateField.vue?vue&type=script&lang=js"

import "./PersianDateField.vue?vue&type=style&index=0&id=5590bb63&lang=css"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PersianDateField.vue"]])

export default __exports__